module.exports = __webpack_public_path__ + "static/media/intro-img-1.cd47f551.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/intro/intro-img-1.png
// module id = 1292
// module chunks = 0